<template>
  <div class="flex flex-wrap h-full py-1">
    <div class="flex py-1 mt-1">
      <button class="ml-4" aria-label="Open Menu" @click="drawer">
        <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" class="w-8 h-8 text-cyan-700">
          <path d="M4 6h16M4 12h16M4 18h16"></path>
        </svg>
      </button>
    </div>

    <transition enter-class="opacity-0" enter-active-class="ease-out transition-medium" enter-to-class="opacity-100" leave-class="opacity-100" leave-active-class="ease-out transition-medium" leave-to-class="opacity-0">
      <div @keydown.esc="isOpen = false" v-show="isOpen" class="z-10 fixed inset-0 transition-opacity">
        <div @click="isOpen = false" class="absolute inset-0 bg-black opacity-50" tabHome="0"></div>
      </div>
    </transition>
    <aside class="transform top-0  left-0 p-1 bg-gray-900 fixed h-full overflow-auto ease-in-out transition-all duration-300 z-30" :class="isOpen ? 'translate-x-0' : '-translate-x-full'">
      <ul @click="isOpen = false" class="">
        <li class="pt-8 px-3 text-dusty-gray text-2xl">SchoolBoard</li>

        <li class="mb-5 mt-12">
          <span class="flex px-2 italic ">Public feed</span>
        </li>
        <li class="mb-8">
          <router-link :to="{ name: 'CreateTodolists' }" class="sidebar ">
            <Post />
            <span class="px-3 text-gray-400 text-sm">Create ToDoList</span></router-link
          >
        </li>
        <li class="mb-8">
          <router-link :to="{ name: 'CreatePosts' }" class="sidebar ">
            <Post />
            <span class="px-3 text-gray-400 text-sm">Create Post</span></router-link
          >
        </li>

        <li class="mb-8">
          <router-link :to="{ name: 'UserTodolists' }" class="sidebar ">
            <Book />
            <span class="px-3 text-gray-400 text-sm">My-ToDoList</span>
          </router-link>
        </li>
        <li class="mb-8">
          <router-link :to="{ name: 'UserPosts' }" class="sidebar ">
            <Book />
            <span class="px-3 text-gray-400 text-sm">My-PostList</span>
          </router-link>
        </li>
        <!-- <li class="mb-5 mt-12">
          <span class="flex px-2 italic ">Personal feed</span>
        </li> -->
        <!-- <li class="mb-8">
          <router-link :to="{ name: 'CreateNotes' }" class="sidebar ">
            <Post />
            <span class="px-3 text-gray-400 text-sm">Create Note</span>
          </router-link>
        </li> -->
        <li class="mb-8">
          <router-link :to="{ name: 'Hangman' }" class="sidebar ">
            <Games />
            <span class="px-3 text-gray-400 text-sm">Hangman</span>
          </router-link>
        </li>
        <!-- last sidebar -->
      </ul>
    </aside>
  </div>
</template>

<script>
import Book from "../components/svg/Book.vue"
import Post from "../components/svg/Post.vue"
import Games from "../components/svg/Games.vue"

export default {
  name: "Home",
  components: { Book, Post, Games },
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    // async signOut() {
    //   console.log("signout")
    //   await this.$auth.logout()
    // },
    drawer() {
      this.isOpen = !this.isOpen
    },
  },
  watch: {
    isOpen: {
      immediate: true,
      handler(isOpen) {
        if (process.client) {
          if (isOpen) document.body.style.setProperty("overflow", "hidden")
          else document.body.style.removeProperty("overflow")
        }
      },
    },
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27 && this.isOpen) this.isOpen = false
    })
  },
}
</script>
